import { Layer } from '~/packages/general/variable/spaceTime.types'
import SelfComparisonReport from './selfComparisonReport.component'
import TimeAnalysisReport from './timeAnalysisReport.component'

const reports = {
  selfComparison: SelfComparisonReport,
  timeAnalysis: TimeAnalysisReport,
}

type ComponentProps<T> = T extends React.ComponentType<infer Props> ? Props : never

type ReportTypes = {
  [Key in keyof typeof reports]: ComponentProps<(typeof reports)[Key]>
}

export interface ReportBase {
  reportKey: keyof typeof reports
  reportPayload: Omit<ReportTypes[keyof typeof reports], 'layer'>
}

export type Report = {
  [K in keyof typeof reports]: {
    reportKey: K
    reportPayload: Omit<ReportTypes[K], 'layer'>
  }
}[keyof typeof reports]

export type ReportWithLayer = Report & {
  layer: Layer
}

export default reports
